import React from 'react';
import { Form, FormGroup, FormTextarea } from 'shards-react';

interface FormReasonProps {
  title: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const FormReason = ({ title, onChange }: FormReasonProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Form>
        <FormGroup>
          <label htmlFor="reason">{title}</label>
          <FormTextarea id="reason" className="mb-3" onChange={onChange} />
        </FormGroup>
      </Form>
    </>
  );
};

export default FormReason;
